/* KpiCard — dashboard stat tile for the Overview page. */
import React from "react";
import { P } from "../../shared/constants";
var E = React.createElement;

export default function KpiCard(props){
  var color = props.color || P.pri;
  var bg    = props.bg    || P.priLt;
  return E("div", {
    role:"group",
    "aria-label": props.label,
    /* min-width:0 lets the card shrink inside auto-fit grid tracks so a
       long number doesn't blow out the row. overflow:hidden + text-
       overflow:ellipsis on the value gracefully truncate. */
    style:{padding:16,borderRadius:12,background:bg,
      border:"1px solid "+P.bdr,display:"flex",flexDirection:"column",gap:4,
      minHeight:96,minWidth:0,overflow:"hidden"}
  },
    E("div",{style:{fontSize:10,fontWeight:700,color:color,
      textTransform:"uppercase",letterSpacing:".04em",
      whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}, props.label),
    /* tabular-nums keeps digit columns aligned across cards so the eye
       can compare values without column shift. */
    E("div",{title:props.value!=null?String(props.value):"",
      style:{fontSize:28,fontWeight:900,color:P.slate,lineHeight:1.1,
        fontVariantNumeric:"tabular-nums",
        whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},
      props.value!=null?String(props.value):"—"),
    props.sublabel?E("div",{style:{fontSize:11,color:P.slateM,marginTop:2,
      whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},props.sublabel):null
  );
}
